import { themeVars } from '@styles/themes.css';
import { style, styleVariants } from '@vanilla-extract/css';

export const base = style({
  borderRadius: '8px',
  padding: '0 0.5rem',
  whiteSpace: 'nowrap',
});

const { chip } = themeVars.color;

export const colors = styleVariants({
  blue: { color: chip.blue.text, backgroundColor: chip.blue.background },
  green: { color: chip.green.text, backgroundColor: chip.green.background },
  orange: { color: chip.orange.text, backgroundColor: chip.orange.background },
  grey: { color: chip.grey.text, backgroundColor: chip.grey.background },
  yellow: { color: chip.yellow.text, backgroundColor: chip.yellow.background },
});
